<!-- Page Content -->
<div id="page-content">
  <div class="container">

    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-9 col-sm-12">
        <div id="page-main">
          <section id="event-detail">
            <article class="event-detail">
              <section id="event-header">
                <br>
                <header>
                  <h2 class="event-date">Message from the Dean of the Faculty</h2>
                </header>
                <hr>
              </section><!-- /#course-header -->
              <section id="course-info">
<!--                <header><h2>Dean of the Faculty</h2></header>-->
                <p>
                  The Faculty of Humanities and Social Sciences is the largest faculty at the University of Ruhuna in terms of both student and staff population. Supported by a dedicated and qualified team of academic staff members, academic support staff, and non-academic staff, the faculty strives for excellence in education and research.
                </p>
                <p>
                  Our faculty is committed to producing highly skilled graduates and advancing knowledge in the humanities and social sciences through innovative research. In 2020, we overhauled our degree programs to provide a comprehensive understanding of humanities and social science disciplines, preparing students for professional and disciplined careers. Our primary focus is on enhancing students' abilities to apply their subject knowledge to contemporary social challenges and problem-solving through both classroom learning and field experiences. We strive to develop their independent and critical thinking, logical analysis, effective communication, and teamwork skills.
                </p>
                <p>
                  The faculty comprises ten academic departments: Economics, English Language Teaching, English and Linguistics, Geography, History and Archaeology, Information Technology, Pali and Buddhist Studies, Public Policy, Sinhala, and Sociology. Our outreach programs include diploma and certificate courses in numerous disciplines, aimed at contributing to the socio-economic development of Sri Lanka. The introduction of new academic and research domains has attracted a significant number of students from all provinces of the country.
                </p>
                <p>
                  Our international collaborative programs involve research and educational exchanges with esteemed institutions such as Agder University and the Norwegian University of Life Sciences in Norway; Tribhuvan University in Nepal; University of Hamburg in Germany; COMSATS Institute of Information Technology in Pakistan; University Sains Malaysia; and Transylvania University of Brasov in Romania. These collaborations enhance our intellectual expertise and global engagement.
                </p>
                <p>
                  I view education as a positive force that fosters good citizenship, mutual respect, democratic values, and tolerance of diverse opinions. With our strengths and commitments, I firmly believe that the Faculty of Humanities and Social Sciences at the University of Ruhuna will continue to thrive as a premier center of academic and scientific excellence, recognized both nationally and internationally.
                </p>
              </section><!-- /#course-info -->

            </article><!-- /.course-detail -->
          </section><!-- /.course-detail -->
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->

      <!--SIDEBAR Content-->
      <div class="col-md-3 dean-msg">
        <div id="page-sidebar" class="sidebar">

          <aside class="news-small" id="news-small">
            <br>
            <header>
              <h5>I. Renuka Priyantha (Mr.)</h5>
            </header>
            <br>
            <!-- Dean Image -->
            <img src="assets/img/deam_renuka_priyantha.jpg" width="80%">

          </aside><!-- /.news-small -->

        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->
      <!-- end SIDEBAR Content-->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
